export default __webpack_public_path__ + "static/media/pinecone.d9764b26.svg";